/* Offer a scroll action only while the compact menu has overflowing content. */
(function () {
  'use strict';
  if (window.emzMenuOverflow) return;
  window.emzMenuOverflow = true;
  var current;
  var compact = window.matchMedia('(max-width: 1279px)');

  function attach() {
    var drawer = document.querySelector('.emz-hybrid.emz-rounded #NavDrawer');
    if (current && current.drawer === drawer) { current.queue(); return; }
    if (current) { current.destroy(); current = null; }
    if (!drawer) return;
    var scroller = drawer.querySelector('.drawer__scrollable');
    var hint = drawer.querySelector('[data-emz-menu-scroll-hint]');
    if (!scroller || !hint) return;
    var label = hint.querySelector('[data-emz-menu-scroll-label]');
    var arrow = hint.querySelector('[data-emz-menu-scroll-arrow]');
    if (!label || !arrow) return;
    var frame = 0, disposed = false;

    function update() {
      frame = 0;
      if (disposed) return;
      if (!compact.matches || !drawer.classList.contains('drawer--is-open') || !scroller.clientHeight) {
        hint.hidden = true;
        return;
      }
      // Compare against the space available without the cue to avoid a resize loop.
      var available = scroller.clientHeight + (hint.hidden ? 0 : hint.offsetHeight);
      var overflow = scroller.scrollHeight > available + 1;
      hint.hidden = !overflow && document.activeElement !== hint;
      var more = scroller.scrollHeight - scroller.clientHeight - scroller.scrollTop > 2;
      hint.classList.toggle('is-at-end', !more);
      label.textContent = more ? 'More below' : 'Back to top';
      arrow.textContent = more ? '↓' : '↑';
    }
    function reveal() {
      var more = scroller.scrollHeight - scroller.clientHeight - scroller.scrollTop > 2;
      var next = more ? scroller.scrollTop + Math.max(44, scroller.clientHeight * .8) : 0;
      scroller.scrollTo({ top: next, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    }
    function queue() {
      if (!disposed && !frame) frame = window.requestAnimationFrame(update);
    }
    var resize = window.ResizeObserver ? new ResizeObserver(queue) : null;
    function observeContent() {
      if (!resize) return;
      resize.disconnect();
      resize.observe(scroller);
      Array.prototype.forEach.call(scroller.children, function (child) { resize.observe(child); });
    }
    var content = new MutationObserver(function () { observeContent(); queue(); });
    content.observe(scroller, { childList: true, subtree: true, characterData: true });
    var state = new MutationObserver(queue);
    state.observe(drawer, { attributes: true, attributeFilter: ['class'] });
    observeContent();
    scroller.addEventListener('scroll', queue, { passive: true });
    scroller.addEventListener('load', queue, true);
    scroller.addEventListener('transitionend', queue);
    scroller.addEventListener('toggle', queue, true);
    window.addEventListener('resize', queue);
    document.addEventListener('drawerOpen.NavDrawer', queue);
    hint.addEventListener('click', reveal);
    hint.addEventListener('blur', queue);
    queue();
    current = {
      drawer: drawer,
      queue: queue,
      destroy: function () {
        disposed = true;
        if (frame) window.cancelAnimationFrame(frame);
        if (resize) resize.disconnect();
        content.disconnect();
        state.disconnect();
        scroller.removeEventListener('scroll', queue);
        scroller.removeEventListener('load', queue, true);
        scroller.removeEventListener('transitionend', queue);
        scroller.removeEventListener('toggle', queue, true);
        window.removeEventListener('resize', queue);
        document.removeEventListener('drawerOpen.NavDrawer', queue);
        hint.removeEventListener('click', reveal);
        hint.removeEventListener('blur', queue);
        hint.hidden = true;
      }
    };
  }
  document.addEventListener('shopify:section:load', attach);
  document.addEventListener('shopify:section:unload', function (event) {
    if (current && event.target.contains(current.drawer)) { current.destroy(); current = null; }
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', attach, { once: true });
  else attach();
}());
